import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/poshmark-bulk-upload';

export default function Example() {
  return (
    <>
      <Head>
        <title>{"Poshmark's Bulk Listing - List Faster and Sell More"}</title>
        <meta
          name='description'
          content='Reach more buyers by boosting your Poshmark activity through the newest Bulk Upload feature!'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/poshmark-bulk-upload' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/poshmark-bulk-upload' />
        <meta property='og:title' content="Poshmark's Bulk Listing - List Faster and Sell More" />
        <meta
          property='og:description'
          content='Reach more buyers by boosting your Poshmark activity through the newest Bulk Upload feature!'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2021-07-14T00:00:00.000Z' />
        <meta property='article:modified_time' content='2021-07-14T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
